import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { useMicroAppStore } from "../store";
import * as Sentry from "@sentry/browser";
var DEFAULT_SENTRY_OPTIONS = {
  // app 自定义运行环境， dev | test | pre | prod
  environment: process.env.REACT_APP_ENV,
  // app 打包环境，一般为development或者production
  releaseEnv: process.env.NODE_ENV,
  // ⭐️ 需要开启监控、上传source map的环境
  watchEnv: ["prod", "test"],
  // 是否开启监控
  canIWatch: function canIWatch() {
    var _process$env$REACT_AP;
    try {
      // 如果已经有sentry配置，不再开启
      if (typeof window !== "undefined") {
        var _sentry$hub;
        var __sentry = window["__SENTRY__"];
        if (!(typeof __sentry === "undefined") && __sentry !== null && __sentry !== void 0 && (_sentry$hub = __sentry.hub) !== null && _sentry$hub !== void 0 && _sentry$hub.getClient()) {
          return false;
        }
      }
    } catch (error) {
      console.warn("in node");
    }
    return this.watchEnv.includes((_process$env$REACT_AP = process.env.REACT_APP_ENV) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : "") && process.env.NODE_ENV === "production";
  },
  // sentry统一配置
  url: "https://sentry.starcharge.com",
  org: "starcharge"
};
var SentryConfigKit = /*#__PURE__*/_createClass(function SentryConfigKit(_options) {
  var _this = this;
  _classCallCheck(this, SentryConfigKit);
  /**配置项 */
  _defineProperty(this, "options", void 0);
  /**
   * 错误忽略
   * @default [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications.",
  ]
   *  */
  _defineProperty(this, "DEFAULT_IGNORE_ERRORS", [/ResizeObserver loop limit exceeded/, /ResizeObserver loop completed with undelivered notifications/]);
  /**
   * 检查是否开启监控,通过options传参覆盖
   * @description 已经存在sentry实例，不再开启；再对env进行匹配判断
   * @default return !window["__SENTRY__"] && this.watchEnv.includes(process.env.REACT_APP_ENV ?? "") && process.env.NODE_ENV === "production";
   */
  _defineProperty(this, "canIWatch", function () {
    var _this$options$canIWat, _this$options;
    return ((_this$options$canIWat = (_this$options = _this.options).canIWatch) === null || _this$options$canIWat === void 0 ? void 0 : _this$options$canIWat.call(_this$options)) || false;
  });
  /**
   * 生成dsn和release
   * @param dsn
   * @param release
   * @returns
   */
  _defineProperty(this, "transformDsnAndRelease", function (dsn, release) {
    var _exec, _exec2;
    // 没有dsn传入，使用默认值
    if (!dsn) {
      return _this.transformDsnAndRelease(_this.options.dsn, _this.options.release);
    }
    var key = (_exec = /^https:\/\/(.+)@{1}/.exec(dsn)) === null || _exec === void 0 ? void 0 : _exec[1];
    var id = (_exec2 = /\/(\d+)$/.exec(dsn)) === null || _exec2 === void 0 ? void 0 : _exec2[1];
    var url = "https://sentry.starcharge.com/api/".concat(id, "/envelope/?sentry_key=").concat(key, "&sentry_version=7&sentry_client=sentry.javascript.browser%2F").concat(Sentry.SDK_VERSION);
    return [url, release];
  });
  /**
   * 发送错误
   * @param error
   * @param errorInfo
   */
  _defineProperty(this, "captureException", function (error, errorInfo) {
    Sentry.captureException(error, {
      extra: errorInfo
    });
  });
  /**
   * 从全局变量monitorConfig_取得微前端的sentry配置池，可以获取子应用配置
   *  */
  _defineProperty(this, "getDsnAndReleaseFromFrame", function (row) {
    var _URL;
    var errorTriggerHost = (_URL = new URL(row.filename)) === null || _URL === void 0 ? void 0 : _URL.host;
    var config = useMicroAppStore.getState().monitorConfig[errorTriggerHost];
    if (config) {
      return _this.transformDsnAndRelease(config.dsn, config.release);
    } else {
      return _this.transformDsnAndRelease();
    }
  });
  /**
   * 改写sentry上传内容，使得主子应用分别提交到不同的地址
   * @param url
   * @param options
   * @returns
   */
  _defineProperty(this, "sentryFilter", /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url, options) {
      var _URL2, body, thirdItem, frames, firstRow, _this$getDsnAndReleas, _this$getDsnAndReleas2, newUrl, newRelease, errorTriggerHost, newBody;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            body = options.body.split("\n");
            thirdItem = body.slice(2);
            body.splice(2);
            body.push(thirdItem.join("\n"));
            body = body.map(function (item) {
              return JSON.parse(item);
            });
            frames = body[2].exception.values[0].stacktrace.frames;
            firstRow = frames[frames.length - 1];
            _this$getDsnAndReleas = _this.getDsnAndReleaseFromFrame(firstRow), _this$getDsnAndReleas2 = _slicedToArray(_this$getDsnAndReleas, 2), newUrl = _this$getDsnAndReleas2[0], newRelease = _this$getDsnAndReleas2[1];
            if (newUrl !== url) {
              // 不一致时说明是子应用传递，子应用由于micro-app加持，行数要-2
              firstRow.lineno = firstRow.lineno - 2;
            }
            errorTriggerHost = (_URL2 = new URL(firstRow.filename)) === null || _URL2 === void 0 ? void 0 : _URL2.host;
            body[2].exception.values[0].stacktrace.frames = frames.filter(function (item) {
              return item.filename.includes(errorTriggerHost);
            });
            newBody = body.map(function (el) {
              return JSON.stringify(el);
            }).join("\n");
            newBody = newBody.replaceAll(new RegExp("\"release\":\"".concat(_this.options.release, "\""), "g"), "\"release\":\"".concat(newRelease, "\""));
            options.body = newBody;
            return _context.abrupt("return", [newUrl, options]);
          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", [url, options]);
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 18]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
  /**
   * 改写sentry上传内容
   * @param options
   * @returns
   */
  _defineProperty(this, "customTransport", function (options) {
    var fetchImpl = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(url, options) {
        var body, _yield$_this$sentryFi, _yield$_this$sentryFi2, newUrl, newOptions;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              body = options.body.split("\n");
              if (!(body.length < 3)) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return", window.fetch(url, options));
            case 3:
              _context2.next = 5;
              return _this.sentryFilter(url, options);
            case 5:
              _yield$_this$sentryFi = _context2.sent;
              _yield$_this$sentryFi2 = _slicedToArray(_yield$_this$sentryFi, 2);
              newUrl = _yield$_this$sentryFi2[0];
              newOptions = _yield$_this$sentryFi2[1];
              return _context2.abrupt("return", window.fetch(newUrl, newOptions));
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function fetchImpl(_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }();
    return Sentry.makeFetchTransport(options, fetchImpl);
  });
  // 必填项校验
  if (!_options.name) {
    throw new Error("name is required");
  }
  // if (!options.authToken) {
  //   throw new Error("authToken is required");
  // }
  if (!_options.dsn) {
    throw new Error("dsn is required");
  }
  if (!_options.version) {
    throw new Error("version is required");
  }
  this.options = _objectSpread(_objectSpread({}, DEFAULT_SENTRY_OPTIONS), _options);
  var $options = this.options;

  // release默认值
  if (!$options.release) {
    $options.release = "".concat($options.name, "-").concat($options.environment, "-").concat($options.version);
  }
  // project预设
  if (!$options.project) {
    $options.project = $options.name;
  }
});
export { SentryConfigKit, Sentry };